import { render, staticRenderFns } from "./notificacoes.vue?vue&type=template&id=0c9a6cb7&"
import script from "./notificacoes.vue?vue&type=script&lang=js&"
export * from "./notificacoes.vue?vue&type=script&lang=js&"
import style0 from "./notificacoes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports